require("core-js/features/number/parse-int");
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import ValidatedFormGroup from "../../Default/common/validated-form-group.vue";
import ValidationMessage from "../../Default/common/validation-message.vue";
import { UtilityTypeFormat, ContractTypeFormat, GenericTypeFormatTranslator } from "../../../../../Scripts/inpulse/FormatUtils";
import { ValidationErrors } from "../../new-contract-vue";
import { IContractViewModel, IMovingSelectionViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import { SectionChecker } from "../../Default/common/section";
import * as moment from "moment-recent"; // moment-recent uses npm moment-library, declared in tsconfig.json and webpack.config.js
import Datepicker from "vuejs-datepicker";
import { fi, sv } from 'vuejs-datepicker/dist/locale'
import Authentication from "./authentication.vue";
import { CustomerTypeEnum, UtilityTypeEnum, ContractTypeEnum, MoveOutReasonEnum } from "@/Scripts/inpulse/CommonEnums";
import { TranslateResult } from 'vue-i18n'
import { NewContractVueHelper } from "../../new-contract-vue-helper";

class Checker extends SectionChecker {
    constructor() {
        super();
        this.properties = [
            (contract: IContractViewModel) => contract.MoveOutProcess.MoveOutDate,
        ];
        this.validationIds = ["movingDate"];
    }
}

export let MoveOutContractsChecker = new Checker();

declare var currentLocale: string;


@Component({
    components: {
        ValidatedFormGroup,
        ValidationMessage,
        Datepicker,
        Authentication
    },
    filters: {
        date(value) {
            let m = moment(value);
            if (m.isValid())
                return m.format("DD.MM.YYYY");
            return value;
        }
    },
    computed: {       
        datePickerlanguage: function () {
            if (currentLocale === "fi") {
                return "fi";
            }
            else if (currentLocale === "sv") {
                return "sv";
            }
        },
        minDate: function () {
            let date = Date.now();
            return this.newContractHelper.getDate(date);
        }
    }
})

export default class MoveOutContractsSelection extends Vue {
    // Map store data to computed properties.
    get moveOutName(): string { return this.$store.state.moveOutUser; }
    get moveOutDate(): string { return this.$store.state.contract.MoveOutProcess.MoveOutDate; }
    get moveOutContracts(): IMovingSelectionViewModel[] { return this.$store.state.contract.MovingOutContracts; }
    get limitFrom(): string { return this.$options.filters.date(new Date().addDays(this.$store.state.contractSettings.MovingMinDates))+ " 00:00:00 GMT"; }
    get limitTo(): string { return this.$options.filters.date(new Date().addYears(1)) + " 00:00:00 GMT"; }   
    get contract(): IContractViewModel { return this.$store.state.contract; }
    get holidays() { return this.$store.state.holidays; }
    get customerType(): CustomerTypeEnum { return this.$store.state.contract.Customer.Id; }
    get authenticationRequired(): boolean {
        return ((this.contract.Company && this.contract.Company.TrustedSource)
            || (this.contract.Customer && this.contract.Customer.TrustedSource)
            || this.trustedCustomer) == false;
    }

    moveOutCustomerName: string = this.$store.state.contract.Customer.FirstName + " " + this.$store.state.contract.Customer.LastName;
    moveOutCompanyName: string = this.$store.state.contract.Company.CompanyName;

    UtilityTypeFormat: typeof UtilityTypeFormat = UtilityTypeFormat;
    ContractTypeFormat: typeof ContractTypeFormat = ContractTypeFormat;

    public contractSelected(contractString: string): boolean {
        console.log("contractSelected: "+contractString)
        return true;
    }

    addMeteringPointToMoveOut(payload: { mp: string, utility: number, moveoutReason: MoveOutReasonEnum, moveoutDate: string }) { return this.$store.dispatch("addMeteringPointToMoveOut", payload); }
    removeMeteringPointFromMoveOut(payload: { mp: string, utility: number }) { return this.$store.dispatch("removeMeteringPointFromMoveOut", payload); }
    setMoveOutDate(payload: { moveOutDate: string }) { return this.$store.dispatch("setMoveOutDate", payload); }

    @Prop()
    public validationErrors: ValidationErrors;

    @Prop()
    public trustedCustomer: boolean;

    newContractHelper: NewContractVueHelper;
    authenticate() { this.showAuthentication = false; }

    showAuthentication: boolean = false;

    CustomerTypeEnum: typeof CustomerTypeEnum = CustomerTypeEnum;
    tmpSelectedMoveOutContracts: string[] = [];
    selectedMoveOutContracts: string[] = [];
    @Watch("selectedMoveOutContracts")
    moveOutContractsChanged() {
        let changedSelectionStr: string = "";
        let addMp = (this.selectedMoveOutContracts.length > this.tmpSelectedMoveOutContracts.length);

        if (addMp) {
            // just checked contract to move out, always last index of selectedMoveOutContracts array
            changedSelectionStr = this.selectedMoveOutContracts[this.selectedMoveOutContracts.length - 1];
        } else {
            // just unchecked contract to move out
            let lastOne: boolean = true;
            for (let i = 0; i < this.selectedMoveOutContracts.length; i++) {
                if (this.selectedMoveOutContracts[i] != this.tmpSelectedMoveOutContracts[i]) {
                    changedSelectionStr = this.tmpSelectedMoveOutContracts[i];
                    lastOne = false;
                    break;
                }
            }
            if (lastOne) {
                changedSelectionStr = this.tmpSelectedMoveOutContracts[this.tmpSelectedMoveOutContracts.length - 1];
            }
        }
        console.log(changedSelectionStr);
        let selectedMoveOutContractsArr = changedSelectionStr.split("|");
        if (selectedMoveOutContractsArr.length == 2) {
            let meteringPointCode = selectedMoveOutContractsArr[0];            
            let utilityTypeId = Number.parseInt(selectedMoveOutContractsArr[1], 10);
            let moveoutReason = MoveOutReasonEnum.MOVEOUT; // all moveouts from online as moveouts, at least for now
            let moveoutDate = this.moveOutDate !== null ? moment(String(this.moveOutDate)).format("DD.MM.YYYY")
                                                        : null;
            if (addMp) {
                this.addMeteringPointToMoveOut({ mp: meteringPointCode, utility: utilityTypeId, moveoutReason: moveoutReason, moveoutDate: moveoutDate })
                    .then(() => console.log(this.$store.state.contract) );
            } else {
                this.removeMeteringPointFromMoveOut({ mp: meteringPointCode, utility: utilityTypeId })
                    .then(() => console.log(this.$store.state.contract));
            }
        }
        // sync tmp values
        this.tmpSelectedMoveOutContracts = this.selectedMoveOutContracts;

        //console.log(this.$store.state.contract);
    }

    movingDate: string = null;
    @Watch("movingDate")
    movingDateChanged(): void {
        let vrtDate = moment(this.moveOutDate);
        if (this.movingDate != vrtDate.format("DD.MM.YYYY")) {
            console.log("movingDate change: " + this.movingDate + " - " + vrtDate.format("DD.MM.YYYY"));
            this.setMoveOutDate({ moveOutDate: moment(String(this.movingDate)).format("DD.MM.YYYY") })
                .then(() => console.log(this.$store.state.contract));
        }
    }
    //@Watch("movingDate")
    //movingDateChanged(v1, v2) {
    //    this.$store.dispatch("changeValue", { key: "MoveOutDate", value: moment(String(this.movingDate)).format('DD.MM.YYYY'), type: PropertyTypeEnum.MeteringPointValue });
    //}

    moveOutDateChangedInput(e: Event): void {
        //let self = this;
        //var target: any = e.target;
        //this.movingDate = target.value;
        let inputStr = (<HTMLInputElement>e.target).value;
        let tmpDate = moment(inputStr, "DD.MM.YYYY");
        if (tmpDate.isValid()) {
            let limitFromDate = moment(this.limitFrom, "DD.MM.YYYY");
            let limitToDate = moment(this.limitTo, "DD.MM.YYYY");
            if (tmpDate.isBetween(limitFromDate, limitToDate, null, "[]")) {
                this.movingDate = tmpDate.format("DD.MM.YYYY");
                (<HTMLInputElement>e.target).value = tmpDate.format("DD.MM.YYYY");
            } else {
                this.movingDate = this.moveOutDate;

                let errorObj: { [key: string]: string } = { "movingDate": "Sopimusten toivottu päättymispäivämäärä täytyy olla välillä "+limitFromDate.format("DD.MM.YYYY")+" - "+limitToDate.format("DD.MM.YYYY") };
                let errors = new ValidationErrors(errorObj);
                this.$emit("notifyValidationError", errors);
            }
        } else {
            this.movingDate = this.moveOutDate;
            (<HTMLInputElement>e.target).value = tmpDate.format("DD.MM.YYYY");

            let errorObj: { [key: string]: string } = { "movingDate": "Päivämäärä tulee syöttää muodossa PP.KK.VVVV" };
            let errors = new ValidationErrors(errorObj);
            this.$emit("notifyValidationError", errors);
        }

        //this.movingDate = inputStr;
    }

    initializeMoveOut() {
        for (let i = 0; i < this.$store.state.contract.MoveOutProcess.ConsumptionPoints.length; i++) {
            let MeteringPointCode = this.$store.state.contract.MoveOutProcess.ConsumptionPoints[i].MeteringPoints[0].MeteringPointCode;
            let UtilityTypeId = this.$store.state.contract.MoveOutProcess.ConsumptionPoints[i].UtilityTypeId;
            let changedSelectionStr = MeteringPointCode + "|" + UtilityTypeId;
            this.selectedMoveOutContracts.push(changedSelectionStr);
        }
        //this.movingDate = this.$options.filters.date(this.movingDate);
        this.movingDate = this.$options.filters.date(this.$store.state.contract.MoveOutProcess.MoveOutDate);
        $("#movingDate-datepicker").attr("aria-label","Valitse sopimusten päättymispäivämäärä");
    }

    constructor() {
        super();
        console.log("constructor() in move-out-contracts-selection.ts");
        console.log(this.$store.state.contract);
        this.newContractHelper = new NewContractVueHelper();
    }

    mounted() {
        let self = this;
        this.initializeMoveOut();
        if (this.$store.state.contract.CustomerContracts.length < 1) {
            console.log("istunto vanhentunut");
            self.$root.$emit("notifySessionException", true);
        }
    }
 
    utilityTypeString(type: UtilityTypeEnum): string | TranslateResult {
        return GenericTypeFormatTranslator.toString(UtilityTypeFormat.toString, type, this.$i18n);
    }

    contractTypeString(type: ContractTypeEnum): string | TranslateResult {
        return GenericTypeFormatTranslator.toString(ContractTypeFormat.toString, type, this.$i18n);
    }

    // returns true for dates to disable
    // ymd: The date as a YYYY-MM-DD string
    // date: The date as a Date object
    disableDates(ymd: string, date: Date): boolean { // used by bootstrap-vue form datepicker
        //let weekend = [0, 6];
        //return this.newContractHelper.disableDates(date, weekend, this.holidays); // disable holidays on moveouts?
        //return this.newContractHelper.disableDates(date, weekend, []); 
        return false;
    }

    data() {
        return {
            DatePickerFormat: "dd.MM.yyyy",
        };
    } 
}